const PERMISSION_KEY= "notification:otp_tracking";
const PAGE_URL = {
    OTP_TRACKING_PAGE: "/admin/notification/otp-tracking"
}

export {PERMISSION_KEY, PAGE_URL}

